function SkeletonLoader() {
    return (
        <div style={{ animation: 'pulse 1.5s ease-in-out infinite', padding: '1.5rem' }}>
            <div style={{ height: '32px', width: '220px', background: '#e2e8f0', borderRadius: '8px', marginBottom: '0.5rem' }} />
            <div style={{ height: '18px', width: '320px', background: '#e2e8f0', borderRadius: '6px', marginBottom: '2rem' }} />
            <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                {[1,2,3].map(i => (
                    <div key={i} style={{ height: '80px', background: '#e2e8f0', borderRadius: '12px' }} />
                ))}
            </div>
            <style>{`
                @keyframes pulse {
                    0%, 100% { opacity: 1; }
                    50% { opacity: 0.4; }
                }
            `}</style>
        </div>
    );
}

export default SkeletonLoader;